import React, { Suspense, lazy } from 'react'
import { Route, Switch /* , Render */ } from 'react-router-dom'
import UserProvider from './contexts/user'
import NotificationProvider from './contexts/notifications'

import {
  LOGIN,
  CATALOG,
  SECURITY,
  REPORTS,
  GIFTTABLE,
  FORGOT,
  RECOVERY,
  PROFILE,
  DASHBOARD,
} from './routes'

// main components
import Header from './components/Header'
import Pannel from './components/Pannel'

// pages
const Login = lazy(() => import('./pages/Login'))
const Forgot = lazy(() => import('./pages/Forgot'))
const Catalog = lazy(() => import('./pages/Catalog'))
const Reports = lazy(() => import('./pages/Reports'))
const Recovery = lazy(() => import('./pages/Recovery'))
const Security = lazy(() => import('./pages/Security'))
const GiftTable = lazy(() => import('./pages/GiftTable'))
const Profile = lazy(() => import('./pages/Profile'))
const Dashboard = lazy(() => import('./pages/Dashboard'))

export default function App() {
  return (
    <NotificationProvider>
      <Switch>
        <Route exact path={LOGIN}>
          <Suspense fallback={<div />}>
            <Login />
          </Suspense>
        </Route>
        <Route exact path={FORGOT}>
          <Suspense fallback={<div />}>
            <Forgot />
          </Suspense>
        </Route>
        <Route exact path={RECOVERY}>
          <Suspense fallback={<div />}>
            <Recovery />
          </Suspense>
        </Route>
        <UserProvider>
          <Header />
          <section className="section">
            <div className="container is-fluid px-0">
              <div className="columns">
                <Pannel />
                <Switch>
                  <Route path={DASHBOARD}>
                    <Suspense fallback={<div />}>
                      <Dashboard />
                    </Suspense>
                  </Route>
                  <Route path={CATALOG}>
                    <Suspense fallback={<div />}>
                      <Catalog />
                    </Suspense>
                  </Route>
                  <Route path={SECURITY}>
                    <Suspense fallback={<div />}>
                      <Security />
                    </Suspense>
                  </Route>
                  <Route path={REPORTS}>
                    <Suspense fallback={<div />}>
                      <Reports />
                    </Suspense>
                  </Route>
                  <Route path={GIFTTABLE}>
                    <Suspense fallback={<div />}>
                      <GiftTable />
                    </Suspense>
                  </Route>
                  <Route path={PROFILE}>
                    <Suspense fallback={<div />}>
                      <Profile />
                    </Suspense>
                  </Route>
                </Switch>
              </div>
            </div>
          </section>
        </UserProvider>
      </Switch>
    </NotificationProvider>
  )
}
